import type { MutationSettings } from '@customTypes/index';
import { useMutation } from '@tanstack/react-query';

import type { RejectWorkRequestParams } from '@/features/work/api/reject-work-request/request';
import { rejectWorkRequest } from '@/features/work/api/reject-work-request/request';

export const useRejectWorkRequestMutation = (
  settings?: MutationSettings<RejectWorkRequestParams, typeof rejectWorkRequest>
) =>
  useMutation({
    mutationKey: ['RejectWorkRequest'],
    mutationFn: ({ params, config }) =>
      rejectWorkRequest({
        params,
        config
      }),
    ...settings?.options
  });
